export default __webpack_public_path__ + "static/media/PFSquareSansProLightItalic_35486.d4d5af91.ttf";